import React from 'react';

type Props = {
    url: string
}

function PlayStoreMarkup({url}: Props) {
    return (<>
{`<a href="${url}">
    <img alt='Get it on Google Play'
         src='https://ngage-storage.ams3.digitaloceanspaces.com/assets/app-badges/google-play-badge.png'
         height=94
    />
</a>`}
    </>);
}

export default PlayStoreMarkup;